import script from "./MST01_002POS.vue?vue&type=script&setup=true&lang=js"
export * from "./MST01_002POS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__